<script lang="ts">
	import LogoTenantHandler from '$lib/components/logo/LogoTenantHandler.svelte'
	import { tenantSettings } from '$lib/domain/tenantSettings/tenantSettings'

	interface Props {
		loading: boolean
	}

	let { loading }: Props = $props()
</script>

{#if loading}
	<div id="ball">
		{#if $tenantSettings.whitelabelEnabled}
			<LogoTenantHandler />
		{:else}
			<svg viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M24.21,29.34a64.59,64.59,0,0,1-18.42,0A6,6,0,0,1,.66,24.21a64.59,64.59,0,0,1,0-18.42A6,6,0,0,1,5.79.66a64.59,64.59,0,0,1,18.42,0,6,6,0,0,1,5.13,5.13,64.59,64.59,0,0,1,0,18.42A6,6,0,0,1,24.21,29.34Z"
					fill="#00b873"
				></path>
				<path
					d="M19.65,16.94h-9.3a.72.72,0,0,1-.72-.72V13.78a.72.72,0,0,1,.72-.72h9.3a.72.72,0,0,1,.72.72v2.44A.72.72,0,0,1,19.65,16.94Zm3-6.4V8.1A.72.72,0,0,0,22,7.38H8.05a.72.72,0,0,0-.72.72v2.44a.73.73,0,0,0,.72.73H22A.73.73,0,0,0,22.67,10.54ZM18.07,21.9V19.46a.73.73,0,0,0-.72-.73h-4.7a.73.73,0,0,0-.72.73V21.9a.72.72,0,0,0,.72.72h4.7A.72.72,0,0,0,18.07,21.9Z"
					fill="#fff"
				></path>
			</svg>
		{/if}
	</div>
	<style>
		@keyframes bounce {
			0% {
				transform: translateY(0);
			}
			100% {
				transform: translateY(-50px);
			}
		}

		#ball {
			margin: 100px auto 0 auto;
			width: 40%;
			max-width: 200px;
			animation: bounce 0.8s;
			animation-direction: alternate;
			animation-iteration-count: infinite;
		}
	</style>
{/if}
